import { setSnackbarMessage } from './snackbarAction';
import { userAddressesFetched, userDestroyAddresses } from './addressAction';
import { isEditingInProgress } from './AppAction';
import {megaDispatch} from './megaDispatch';

//-- Action creators

export const userAuthenticate = (data = null) => {
	return {
		type: 'USER_AUTHENTICATE',
		payload: data
	}
}

export const userSetInactiveState = (data = null) => {
    return {
        type: 'USER_SET_INACTIVE_LOGOUT',
        payload: data
    }
}

export const setUserEmail = str => {
    return {
        type: 'SET_USER_EMAIL',
        payload: str
    }
}

export const setUserPassword = str => {
    return {
        type: 'SET_USER_PASSWORD',
        payload: str
    }
}

export const userReset = (data = null) => {
    return {
        type: 'USER_RESET',
        payload: data
    }
}

export const userRoutesFetched = routesData => {
    return {
        type: 'USER_ROUTES_FETCH_SUCCESS',
        payload: routesData
    }
}

export const userFetchDataSuccess = userData => {
    return {
        type: 'USER_FETCH_DATA_SUCCESS',
        userData
    };
}

export const userVerified = userData => {
    return {
        type : 'USER_VERIFIED',
        userData
    }
}

export const userUpdated = userData => {
    return {
        type : 'USER_UPDATED',
        userData
    }
}

export const childUserUpdated = (userData, userIndex) => {
    return {
        type : 'CHILD_USER_UPDATED',
        payload: {
            userData,
            userIndex
        }
    }
}

export const childUserCreated = (userData) => {
    return {
        type : 'CHILD_USER_CREATED',
        payload: {
            userData
        }
    }
}

export const childUsersFetched = userData => {
    return {
        type : 'CHILD_USERS_FETCHED',
        userData
    }
}

export const setUserPasswordResetSuccess = (bool) => {
    return {
        type: 'USER_PASSWORD_SUCCESS',
        payload: bool
    }
}

export const updateUser = (url, userData, childIndex = false, parentId = false, token = false, clientPath = false, fetchSubUserParentID = false) => {
    let data = new FormData();

    if(parentId != false) {
        userData.parent_id = parentId;
    }




    data.append('data', JSON.stringify(userData) );

    if(token !== false && clientPath !== false) {
        data.append("set_first_login_false", true);
    }
    return (dispatch) => {
        dispatch(isEditingInProgress('editUser',true));
        fetch(url,
        {
            method: "POST",
            body: data
        })
        .then((response) => {
            if (!response.ok) {
                dispatch(isEditingInProgress('editUser',false));
                throw Error(response.statusText);
            }
            return response;
        })
        .then((response) => response.json())
        .then((items) => {
            dispatch(isEditingInProgress('editUser',false));
            dispatch(setSnackbarMessage(items.flash_message));
            if(items.type == 'success') {
                if(token != false && clientPath != false) {
                    dispatch(fetchRoutesForUser(clientPath + '/api/user/action/getRoutes', userData.user_id, token));
                }
                if(parentId === false) {
                    if(childIndex !== false) {
                        dispatch(childUserUpdated(items.user_profile, childIndex));
						
						
						if ( fetchSubUserParentID ) {
							
							dispatch(fetchChildUsers(clientPath + '/api/user/action/getChildUsers', fetchSubUserParentID, false))
						}

                    }else{
                        dispatch(userUpdated(items.user_profile));

                    }
                }else{
                    // -- Parent ID is set, this is only necessary for a new user. Therefore, create.
                    dispatch(childUserCreated(items.user_profile));
                }
            }
        })
        .catch(() => {
            dispatch(isEditingInProgress('editUser',false));
            //dispatch(setSnackbarMessage('Er heeft zich een fout voorgedaan.'));
        });
    };
}


export const updateUserPassword = (url, userData, childIndex = false, parentId = false, token = false, clientPath = false) => {
    let data = new FormData();

    if(parentId !== false) {
        userData.parent_id = parentId;
    }



    data.append('data', JSON.stringify(userData) );

    if(token !== false && clientPath !== false) {
        data.append("set_first_login_false", true);
    }
    return (dispatch) => {
        dispatch(isEditingInProgress('editUser',true));
        fetch(url,
        {
            method: "POST",
            body: data
        })
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return response;
        })
        .then((response) => response.json())
        .then((items) => {
            dispatch(isEditingInProgress('editUser',false));
            dispatch(setSnackbarMessage(items.flash_message));
            if(items.type === 'success') {
                if(token !== false && clientPath !== false) {
                    dispatch(fetchRoutesForUser(clientPath + '/api/user/action/getRoutes', userData.user_id, token));
                }
                if(parentId === false) {
                    if(childIndex !== false) {
                        dispatch(childUserUpdated(items.user_profile, childIndex));
                    }else{
                        dispatch(userUpdated(items.user_profile));
                    }
                }else{
                    // -- Parent ID is set, this is only necessary for a new user. Therefore, create.
                    dispatch(childUserCreated(items.user_profile));
                }
            }
        })
        .catch(() => {
            dispatch(isEditingInProgress('editUser',false));
            //dispatch(setSnackbarMessage('Er heeft zich een fout voorgedaan.'));
        });
    };
}

// -- This action sends a request to the server, using the users e-mail address.
export const userFetchData = (url, postData) => {
    let data = new FormData();
    data.append('data', JSON.stringify(postData) );
    data.append('webApp', '1');

    return (dispatch) => {

        dispatch(setUserEmail(postData.user_email));
        dispatch(isEditingInProgress('fetchUser',true));
        dispatch(setUserPassword(postData.password));

        fetch(url,
        {
            method: "POST",
            body: data
        })
        .then((response) => {

            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response;
        })
        .then((response) => response.json())
        .then((items) => {

            dispatch(isEditingInProgress('fetchUser',false));
            if(!items.error_message) {

                dispatch(userFetchDataSuccess(items))

                if(items.user_verified) {
                   
                    dispatch(userVerified(items))
                    dispatch(userAddressesFetched(items.user_profile.addresses));
                }

            }else{
                dispatch(setSnackbarMessage(items.error_message));

            }
        })
        .catch(() => {
            dispatch(isEditingInProgress('fetchUser',false));
            //dispatch(setSnackbarMessage('Er heeft zich een fout voorgedaan.'));
        });
    };
}

// -- This function verifies the user after they applied their verification code.
export const verifyUser = (url, postData, userData) => {
    let data = new FormData();

    data.append('data', JSON.stringify(postData));
    data.append('userData', JSON.stringify(userData));
    data.append('webApp', '1');
    return (dispatch) => {
        dispatch(isEditingInProgress('verifyUser',true));
        fetch(url,
        {
            method: "POST",
            body: data
        })
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response;
        })
        .then((response) => response.json())
        .then((items) => {
            dispatch(isEditingInProgress('verifyUser',false));
            if(!items.error_message) {

                dispatch(userVerified(items))
                dispatch(userAddressesFetched(items.user_profile.addresses));
            }else{
                dispatch(setSnackbarMessage(items.error_message));
                dispatch(userSetInactiveState(items.user_inactive_logout));
            }
        })
        .catch(() => {
            dispatch(isEditingInProgress('verifyUser',false));
            //dispatch(destroySession());
           // dispatch(setSnackbarMessage('Er heeft zich een fout voorgedaan.'));
        });
    };
}

//-- This action fetches the routes based on a user ID
export const verifyUserWithToken = (url, user_id, user_token, showEditProgress) => {
    let data = new FormData();

    data.append('user_id', user_id );
    data.append('user_token', user_token );
    data.append('webApp', '1');
    return (dispatch) => {
        dispatch(isEditingInProgress('verifyUserWithToken',showEditProgress === true ? true : false));
        fetch(url,
        {
            method: "POST",
            body: data
        })
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response;
        })
        .then((response) => response.json())
        .then((items) => {
            dispatch(isEditingInProgress('verifyUserWithToken',false));
            dispatch(userSetInactiveState(items.user_inactive_logout));
            if(items.error_message) {
                dispatch(setSnackbarMessage(items.error_message));
            }
        })
        .catch((Exception) => {
            dispatch(isEditingInProgress('verifyUserWithToken',false));
           // dispatch(destroySession());
            //dispatch(setSnackbarMessage('Er heeft zich een fout voorgedaan.'));
        });
    };
}

//-- This action fetches the routes based on a user ID
export const fetchRoutesForUser = (url, user_id, user_token, showEditProgress) => {
    let data = new FormData();

    data.append('user_id', user_id );
    data.append('user_token', user_token );
    return (dispatch) => {
        dispatch(isEditingInProgress('routes',showEditProgress === true ? true : false));
        fetch(url,
        {
            method: "POST",
            body: data
        })
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response;
        })
        .then((response) => response.json())
        .then((items) => {
            dispatch(isEditingInProgress('routes',false));
            if(!items.error_message) {
                dispatch(userRoutesFetched(items))
            }else{
                dispatch(setSnackbarMessage(items.error_message));
            }

        })
        .catch(() => {
            //dispatch(setSnackbarMessage('Er heeft zich een fout voorgedaan tijdens het laden van uw menu'));
        });
    };
}

//-- This action fetches the child users based on a user ID
export const fetchChildUsers = (url, user_id, showEditProgress) => {
    let data = new FormData();

    data.append('user_id', user_id );
    return (dispatch) => {
        dispatch(isEditingInProgress('childUsers',showEditProgress === true ? true : false));
        fetch(url,
        {
            method: "POST",
            body: data
        })
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response;
        })
        .then((response) => response.json())
        .then((items) => {
            dispatch(isEditingInProgress('childUsers',false));
            if(items.flash_message) {
                dispatch(setSnackbarMessage(items.flash_message));
            }

            if(items.data) {
                dispatch(childUsersFetched(items.data))
            }


        })
        .catch(() => {
            dispatch(isEditingInProgress('childUsers',false));
            //dispatch(setSnackbarMessage('Er heeft zich een fout voorgedaan.'));
        });
    };
}


export const setClientRepresentative = (url, client_id, user_id, user_token, clientPath) => {
    let data = new FormData();

    data.append('client_id', client_id );
    data.append('user_id', user_id );

    return (dispatch) => {
        dispatch(isEditingInProgress('clientRepresentative',true));
        dispatch(userDestroyAddresses());
        fetch(url,
        {
            method: "POST",
            body: data
        })
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response;
        })
        .then((response) => response.json())
        .then((items) => {
           dispatch(isEditingInProgress('clientRepresentative',false));
           dispatch(setSnackbarMessage('Succesvol een klant gekozen'));
           dispatch(userUpdated(items.user_profile));
           dispatch(userAddressesFetched(items.user_profile.addresses));
           dispatch(megaDispatch(clientPath, user_id, user_token, true, items.user_profile.selectedRepresentativeUserId));

        })
        .catch(() => {
            //dispatch(setSnackbarMessage('Er heeft zich een fout voorgedaan.'));
        });
    };
}

export const resetPassword = (url, user_email) => {
    let data = new FormData();
    data.append('user_email', user_email.user_email );
    return (dispatch) => {
        dispatch(isEditingInProgress('resetPassword',true));
        fetch(url,
        {
            method: "POST",
            body: data
        })
        .then((response) => {

            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response;
        })
        .then((response) => response.json())
        .then((items) => {
            dispatch(isEditingInProgress('resetPassword',false));
            if(items.message) {
               dispatch(setSnackbarMessage(items.message));
            }

            if(items.type === 'success') {
                dispatch(setUserPasswordResetSuccess(true));
            }
        })
        .catch(() => {
            //
        });
    };
}


export const updateUserSetting = (url, user_id, settings) => {
    let data = new FormData();

    data.append('user_id', user_id);
    data.append('settings', JSON.stringify(settings) );
    return (dispatch) => {
        fetch(url,
        {
            method: "POST",
            body: data
        })
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response;
        })
        .then((response) => response.json())
        .then((items) => {

            items = JSON.parse(items);
            dispatch(setSnackbarMessage(items.message));
            if(items.type === 'success') {
                //dispatch(settingsUpdated(items.user_profile, childIndex));
                dispatch(userUpdated(items.user_profile));

            }else{
                dispatch(setSnackbarMessage('Gebruiker aangemaakt.'));
            }

        })
        .catch(() => {
          //  dispatch(setSnackbarMessage('Er heeft zich een fout voorgedaan.'));
        });
    };
}
export const userAgreedToTerms = (object) => {
    return {
        type: 'USER_AGREED_TO_TERMS',
        payload: object
    }
}

export const agreeToTerms = (url, user_id) => {
    let data = new FormData();

    data.append('user_id', user_id );
    return (dispatch) => {
        fetch(url,
        {
            method: "POST",
            body: data
        })
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response;
        })
        .then((response) => response.json())
        .then((items) => {

            items = JSON.parse(items);
            if(items.message) {
               dispatch(setSnackbarMessage(items.message));
            }

            if(items.type === 'success') {
                dispatch(userAgreedToTerms(items.data));
            }
        })
        .catch(() => {
            //
        });
    };
}



// WEBPACK FOOTER //
// ./src/redux/actions/userAction.js